import React from 'react';

import {
    Footer,
    Meta,
    Navigation
} from '$partials/global/index.js';

import ModuleDispatcher from '$partials/modules/dispatcher.jsx';
import HomePageHero from './home-page-hero';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').HomePage}
 */

const HomePage = ({ data, domain }) => {

    const page = data?.page;

    if (!page) { return null; }

    return (
        <>
            <Meta
                page={page} />

            <Navigation navigation={data?.navigation} />

            <main id='main-content'>
                <div className='min-h-screen'>

                    <h1
                        className='sr-only'
                        dangerouslySetInnerHTML={{ __html: page?.animatedHeroText?.json?.content?.map((block) => block.content.map((node) => node.value).join('')).join('') }}/>

                    <HomePageHero
                        bodyCopy={page?.bodyCopy}
                        cta1Label={page?.ctaLabel}
                        cta1Link={page?.ctaLink}
                        cta2Label={page?.cta2Label}
                        cta2Link={page?.cta2Link}
                        eyebrow={page?.eyebrow}
                        heroMedia={page?.heroMedia}
                        heroText={page?.animatedHeroText}
                        polyline={page?.polyline}
                        statistics={page?.statistics} />

                    {/* Content */}
                    {(page?.modules?.items?.length > 0) && (
                        page.modules.items.map((module, i) => {
                            if (!module) { return null; }
                            return (
                                <ModuleDispatcher
                                    key={i}
                                    module={module}
                                    previousTypename={page.modules.items[i - 1]?.__typename ?? null}
                                    nextTypename={page.modules.items[i + 1]?.__typename ?? null}/>
                            );
                        })
                    )}

                    <div className='pt-8'>
                        <Footer
                            domain={domain}
                            menu={data?.footer} />
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default HomePage;
